export default {
  infoText:
    'Die Tabelle zeigt Berater die sich im Status "in Bearbeitung" befinden und ein Startdatum hinterlegt haben',
};
